import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enPaymentMethod } from 'enums/enPaymentMethod';

interface IProps {
  model: IThankYou;
}

const Ticket: React.FC<IProps> = ({ model }) => {
  const textInformation = {
    [enPaymentMethod.BANKSLIP]: (
      <p>
        Você receberá seu ticket no seu <b>e-mail</b> assim que o pagamento do boleto for confirmado. Enquanto isso, confirme os seus dados de compra.
      </p>
    ),
    [enPaymentMethod.PAGDIVIDIDO]: (
      <p>
        Fique atento, você receberá um <b>SMS</b> para finalizar o processo. Após finalizado você receberá no seu <b>e-mail</b> o ticket do evento.
        Enquanto isso, confirme os seus dados de compra.
      </p>
    )
  };
  return (
    <React.Fragment>
      <div className={'message'}>
        {textInformation[model.paymentResult.paymentMethod] ?? (
          <p>
            Estamos preparando com carinho a entrega do seu ticket. Você receberá no seu <b>e-mail</b> o ticket do evento. Enquanto isso, confirme os
            seus dados de compra.
          </p>
        )}
      </div>
      <div className={'data'}>
        <div className={'user'}>
          <p>
            <SvgIcon name="user" />
            <span>{model.studdent ? model.studdent.name : model.user.name}</span>
          </p>
          <p>
            <SvgIcon name="email" />
            <span>{model.studdent ? model.studdent.email : model.user.email}</span>
          </p>
        </div>
      </div>
      <div className="alert">
        Em caso de dúvidas, ou se você precisar de suporte, entre em contato com o vendedor pelo e-mail <b>{model.content.producerEmail}</b>.
      </div>
    </React.Fragment>
  );
};

export default React.memo(Ticket);
